<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      :disabled="disablePopOver"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
          class="focus"
        >
          <img v-if="buttonIcon" :src="buttonIcon" alt="about us" style="max-width: 20px" class="mr-2"/>
         {{buttonText}}
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-center">
                <b>{{titleText}}</b>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list>
          <v-list-item v-for="(option, index) in optionList" :key="index">
            <v-list-item-title>{{option.label}}</v-list-item-title>
            <v-list-item-action>
              <v-checkbox :input-value="valueList" :value="option.key" @change="check($event, option.key)" ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>


<script>
export default {
  name: 'PopoverMenu',
  props: ['valueList', 'optionList', 'titleText', 'buttonIcon', 'buttonText', 'defaultListItem', 'disablePopOver'],
  data: function () {
    return {
      menu: false,
      selected: [],
    }
  },
  methods:{
    check:function (value, key){
      if (key === 'all') {
        // checkbox all
        if (value.includes(key)) {
          value = this.defaultListItem
        } else {
          value = []
        }
      } else if (this.defaultListItem.includes('all')) {
        // checkbox item
          if (value.length === this.defaultListItem.length - 1) {
            if (value.includes('all')) {
              // checkbox item remove
              value = value.filter((x) => x !== 'all')
            } else {
              value = this.defaultListItem
            }
          }
      }
      this.$emit('change-value-filter-list', value, key)
    },
  },
}
</script>

<style lang="scss">
  .active {
    background-color: #6ec39b;
    color: #ffffff;
  }

  .v-btn.focus:hover:before, .v-btn.focus:focus:before {
    background-color: #6ec39b !important;
  }
</style>
